import { FC, useContext, useMemo } from 'react'

import { Accordion } from 'core-components/library/accordion'
import { APLTranslationCodes } from 'onboarding/configs/translations/aplTranslationCodes'
import { LanguageContext } from 'onboarding/context/LanguageContext'

import { AplDocumentTypes, IAplDocument } from '../../models/aplDocument'

import { DocumentsList } from './components/documentsList/DocumentsList'
import { getUploadHistory } from './helpers/getUploadHistory'

import styles from './DocumentsHistory.module.scss'

interface IDocumentsHistoryProps {
  documents: IAplDocument[]
}

export const DocumentsHistory: FC<IDocumentsHistoryProps> = ({ documents }) => {
  const { t } = useContext(LanguageContext)

  const historyItems = useMemo(() => {
    return getUploadHistory(documents)
  }, [documents])

  return (
    <div className={styles.root}>
      {historyItems.map((entry) => {
        const [date, documents] = entry

        const tnc = documents.filter((doc) => doc.Type === AplDocumentTypes.TC)
        const sdc = documents.filter((doc) => doc.Type === AplDocumentTypes.SDC)

        return (
          <Accordion key={date} title={date}>
            <div className={styles.accordionContent}>
              <DocumentsList
                label={t(APLTranslationCodes.document_history_terms_and_condition_title)}
                documents={tnc}
              />
              <DocumentsList
                label={t(
                  APLTranslationCodes.document_history_selective_distribution_criteria_title
                )}
                documents={sdc}
              />
            </div>
          </Accordion>
        )
      })}
    </div>
  )
}
